export const BASEURL = "https://bbapi.nayatel.com/api/api/web/";  //LIVE 
export const CONTENT_BASEURL = "https://bbcontent.nayatel.com/";
// export const CONTENT_BASEURL = "https://devbbcontent.nayatel.com/";
export const API_BASEURL = "https://api.nayatel.com/creatives/BoostBoard/";
export const MAX_UPLOAD_FILE_SIZE = 1073741824
